'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbEnterPressed = fbEnterPressed;
function fbEnterPressed() {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            elem.bind('keyup', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.dbwEnter, { event: event });
                    });
                    event.preventDefault();
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-enter-pressed.js
// module id = 713
// module chunks = 0